import { useSelector } from 'react-redux'
import { StoreState } from '@/store'
import useRegionOptions from '@/hooks/useRegionOptions'

const useCurrencyOptions = () => {
  const { region } = useSelector((state: StoreState) => state.ssr)
  const { usOption, regionOptions } = useRegionOptions()
  const activeRegion = regionOptions.find((item) => item.region === region)

  const currencyOptions = [
    {
      label: `${usOption?.label}(${usOption?.sign})`,
      value: usOption?.value ?? 'USD'
    }
  ]
  if (region !== usOption?.region && region !== '' && activeRegion?.value) {
    currencyOptions.unshift({
      label: `${activeRegion.label}(${activeRegion.sign})`,
      value: activeRegion.value
    })
  }

  return currencyOptions
}

export default useCurrencyOptions
